import { additionalUserFields, AUTH_PATH_PREFIX } from '@tandemone/types'
import {
  emailOTPClient,
  inferAdditionalFields
} from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'

export const authClient = createAuthClient({
  basePath: AUTH_PATH_PREFIX,
  plugins: [
    emailOTPClient(),
    inferAdditionalFields({ user: additionalUserFields })
  ],
  fetchOptions: {
    /** better-auth uses its own fetch, not the axios client, so stamp the same
     *  x-request-id the axios interceptor sets. fastify adopts it
     *  (requestIdHeader) so auth requests correlate to one request_id in logs.
     */
    onRequest: context => {
      context.headers.set('x-request-id', crypto.randomUUID())
      return context
    }
  }
})
